<template>
    <div class="ui-menu-item" @click="handleClick">
        <WBIcon v-if="icon"
                class="ui-menu-item__icon"
                :name="icon"
        />
        <slot>
            {{ text }}
        </slot>
    </div>
</template>

<script lang="ts" setup>
    import type { UiMenuItemProps } from './types'

    withDefaults(defineProps<UiMenuItemProps>(), {
        icon: '',
        text: ''
    })
    const emit = defineEmits(['click'])
    const closeUiMenu = inject<() => void>('closeUiMenu')

    function handleClick(e: Event) {
        closeUiMenu()
        emit('click', e)
    }
</script>

<style lang="scss" scoped>
    .ui-menu-item {
        display: flex;
        align-items: center;
        min-height: 36px;
        padding: 0 12px;
        border-radius: 7px;
        color: var(--black);
        cursor: pointer;

        @include manrope14m;

        @include hover {
            background-color: var(--indigo-50);
            color: var(--blue-600);
        }

        &__icon {
            margin-right: 8px;
            font-size: 20px;
        }
    }
</style>
